module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/skyswitch-sso/skyswitch-sso.component.css
// module id = ./src/app/skyswitch-sso/skyswitch-sso.component.css
// module chunks = main